import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ClBackdrop extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  public invisible!: boolean;
}
